<template>
  <div class="embedded-kiosk">
    <EmbeddedKioskPowerBIReport
      :reportId="reportId"
      :hasSubmit="false"
      ref="powerBIReport"
    />
  </div>
</template>

<script>
import EmbeddedKioskPowerBIReport from '@/Core.Service.Domain/ViewSupport/Kiosk/Components/KioskPowerBIReport.vue';

export default {
  name: 'EmbeddedKiosk',

  data() {
    return {
      reportId: this.$route.params.id,
      isLoading: true,
      loader: 'dots',
      loaderOpacity: 100,
      loadTimer: this.$route.params.loadTimer ?? 9000,
    };
  },

  components: {
    EmbeddedKioskPowerBIReport,
  },

  created() {
    setTimeout(() => {
      this.isLoading = false;
    }, this.loadTimer);
  },
};
</script>
